$(document).on('turbolinks:load', function () {
  var employeeUpdateShowGenerateData = $('#employee-update-show-generate-data');
  if (employeeUpdateShowGenerateData.length) {
    employeeUpdateShowGenerateData.on("click", function(){
      $('#overlay-on-submit-layer-js').removeClass("d-none");
    });
  }
});